module.exports = __webpack_public_path__ + "static/media/blog3.984326a6.jpg";